module.exports = __webpack_public_path__ + "static/media/StripeIntegration.512a11c6.pdf";